import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ isMobileOpen, setIsMobileOpen }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [userRole, setUserRole] = useState('user');

  useEffect(() => {
    const token = localStorage.getItem('capstonne_access_token');
    if (token) {
      try {
        // 🚨 ROBUST DECODING: Handles standard JWT Base64URL encoding
        const parts = token.split('.');
        if (parts.length === 3) {
          const base64Url = parts[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join('')
          );
          
          const payload = JSON.parse(jsonPayload);
          
          // 🚨 THE FIX: Check for 'privilege' exactly like we did in App.jsx!
          const role = payload.privilege || payload.role || 'user';
          setUserRole(role.toLowerCase());
        }
      } catch (error) {
        console.error("Could not decode token payload in Sidebar", error);
      }
    }
  }, []);

  // ── 1. User Menu Items ──
  const userMenuItems = [
    { 
      name: 'Dashboard', 
      path: '/dashboard/userdashboard', // 👈 Fixed path to match Router!
      icon: 'M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z' 
    },
    { 
      name: 'My Customers', 
      path: '/dashboard/my_customers', 
      icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' 
    },
    { 
      name: 'Payments', 
      path: '/dashboard/payments', 
      icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z' 
    },
    { 
      name: 'Installments', 
      path: '/dashboard/installments', 
      icon: 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4' 
    },
    { 
      name: 'Coupons', 
      path: '/dashboard/my_coupons', 
      icon: 'M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4' 
    },
  ];

  // ── 2. Admin Menu Items ──
  const adminMenuItems = [
    { 
      name: 'Admin Overview', 
      path: '/dashboard/admin', 
      icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' 
    },
    { 
      name: 'All Users', 
      path: '/dashboard/admin/all_customers', 
      icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' 
    },
    { 
      name: 'All Payments', 
      path: '/dashboard/admin/all_payments', 
      icon: 'M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z'
    },
    { 
      name: 'All KYC', 
      path: '/dashboard/admin/all_kyc', 
      icon: 'M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2'
    },
    { 
      name: 'All Bank Details', 
      path: '/dashboard/admin/all_bank_details', 
      icon: 'M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z'
    },
  ];

  const activeMenuItems = userRole === 'admin' ? adminMenuItems : userMenuItems;

  // Tooltip needs to return something!
  const Tooltip = ({ label }) => {
    return (
      <span className="pointer-events-none absolute left-full ml-3 px-2.5 py-1.5 bg-slate-800 dark:bg-slate-700 text-white text-xs font-semibold rounded-lg whitespace-nowrap shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-[9999]">
        {label}
      </span>
    );
  };

  return (
    <>
      {isMobileOpen && (
        <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden backdrop-blur-sm transition-all duration-300" onClick={() => setIsMobileOpen(false)} />
      )}

      <aside
        className={`fixed lg:static inset-y-0 left-0 z-50 flex flex-col bg-white dark:bg-slate-800 border-r border-slate-200 dark:border-slate-700 shadow-2xl lg:shadow-none overflow-visible transition-all duration-300 ease-in-out
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
          ${isCollapsed ? 'lg:w-[72px] w-[280px]' : 'lg:w-[280px] w-[280px]'}
        `}
      >
        {/* Collapse Toggle */}
        <div className="group hidden lg:block absolute -right-3.5 top-24 z-50">
          <button onClick={() => setIsCollapsed(!isCollapsed)} className="w-7 h-7 flex items-center justify-center rounded-full bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 text-slate-500 dark:text-slate-300 hover:text-blue-600 shadow-sm focus:outline-none transition-all">
            <svg className={`w-4 h-4 transition-transform duration-300 ${isCollapsed ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>

        {/* Brand Header */}
        <div className={`flex items-center h-20 border-b border-slate-100 dark:border-slate-700 flex-shrink-0 ${isCollapsed ? 'justify-center px-0' : 'justify-start px-6'}`}>
          <div className="flex items-center gap-3 whitespace-nowrap">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center flex-shrink-0 shadow-md shadow-blue-500/20">
              <span className="font-extrabold text-xl text-white">C</span>
            </div>
            {!isCollapsed && (
              <h1 className="text-xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100">
                Capstonne<span className="text-blue-500">.</span>
              </h1>
            )}
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 py-5 space-y-1 w-full overflow-visible">
          {activeMenuItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setIsMobileOpen(false)}
              // "end" ensures exact path matching so highlights don't bleed
              end={item.path === '/dashboard/userdashboard' || item.path === '/dashboard/admin'} 
              className={({ isActive }) =>
                `group relative flex items-center py-3 rounded-xl transition-all duration-200 font-semibold text-[14.5px]
                 ${isActive
                   ? 'bg-blue-600 text-white shadow-md shadow-blue-500/20 dark:shadow-blue-900/30'
                   : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 hover:text-slate-900 dark:hover:text-white'
                 }
                 ${isCollapsed ? 'justify-center mx-3' : 'px-4 mx-4'}`
              }
            >
              <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={item.icon} />
              </svg>

              {!isCollapsed && <span className="ml-3.5 whitespace-nowrap">{item.name}</span>}
              {isCollapsed && <Tooltip label={item.name} />}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;